export const SHOW_SHARE_MODAL = "UI/SHARE_MODAL/SHOW";
export const HIDE_SHARE_MODAL = "UI/SHARE_MODAL/HIDE";
